<script>
  import { layoutMethods, customerLiteMethods, customerListLiteComputed, peddlrWalletKycLiteMethods} from "@/state/helpers";
  import profileHeader from "@/views/pages/_version_2_/peddlr-lite/merchant/profileInformation/profileHeader.vue";
  import profileWallet from "@/views/pages/_version_2_/peddlr-lite/merchant/profileInformation/profileWallet.vue";
  import profileGenerateKyc from "@/views/pages/_version_2_/peddlr-lite/merchant/profileInformation/profileGenerateKyc.vue";
  import profileInformation from "@/views/pages/_version_2_/peddlr-lite/merchant/profileInformation/profileInformation.vue";
  import profileKycDetails from "@/views/pages/_version_2_/peddlr-lite/merchant/profileInformation/profileKycDetails.vue";
  // ponytail: no separate "Business Data" tab in the Peddlr Lite merchant detail design — the
  // business info is shown within profileInformation. profileBusinessData is intentionally omitted.
  import profileMdrSettings from '@/views/pages/_version_2_/peddlr-lite/merchant/profileInformation/profileMdrSettings.vue';

  /**
   * Profile Information component
   */
  export default {
    page: {
      title: "Profile Information"
    },
    components: {
      profileHeader,
      profileWallet,
      profileGenerateKyc,
      profileInformation,
      profileKycDetails,

      profileMdrSettings
    },
    computed: {
      ...customerListLiteComputed
    },
    data() {
      return {
        title     : "Account Profile",
        userId    : 0,
        businessId: 0,
        infoType  : null,
      };
    },
    methods: {
      ...layoutMethods,
      ...customerLiteMethods,
      ...peddlrWalletKycLiteMethods,
      reload(){
        this.getBusinessDetailsv2({id: this.businessId});
      }
    },
    async mounted(){
      this.userId = this.$route.params.id
      this.businessId = this.$route.params.bid
      this.infoType = this.$route.params.tab;
      this.changeTitle({title: this.title});
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'} },
          { text: 'Peddlr Lite (Merchant)', to: { name: 'Merchant Lite'} },
          { text: 'Account Profile', to: { name: 'Lite Profile Information', params: { tab: this.infoType, bid: this.businessId }} }
        ]
      });
      
      //this will initialize businessDetails
      await this.getBusinessDetailsv2({id: this.businessId}).then(async()=>{
        await this.getUserKycStatus({userId: this.businessDetails.subscriberId});
      });
      // console.log(":: this.businessDetails ::",JSON.stringify(this.businessDetails));
      // await this.getUserKycStatus({userId: this.businessDetails.subscriberId});
      // console.log(":: this.userKycStatus ::",JSON.stringify(this.userKycStatus));
    }
  }
    
</script>


<template>
  <div class="row"><!-- outer div-->
    <button style="display: none;" @click="reload">reload</button>
    <div class="col-xl-3">
      <profile-header/>
      <profile-wallet/>
      <profile-generate-kyc/>
      <profile-mdr-settings/>
    </div>
    <div class="col-xl-9">
      <!-- v-bind:mainData="{sid: userId, bid: businessId, infoType: infoType}" -->
      <profile-information/>
      <profile-kyc-details/>
      <!--profile-business-data/-->
    </div>
  </div> <!-- end of outer div-->
</template>


<style>
</style>